export default {
  title: 'Assine nossa newsletter!',
  subtitle: 'Receba conteúdos exclusivos',
  messages: {
    error: 'Este e-mail já fez uma assinatura!',
    success: 'Parabéns pela assinatura!'
  }
}
